import Header from '../Header2';
import "../../styles/grid.css";
import Vector from "../../assets/svg/editIcon.svg";
import Delete from "../../assets/svg/DeleteIcon.svg";
import { useState, useRef, useEffect } from "react";
import DatePicker from "../../Component/DatePicker";
import ReactPaginate from "react-paginate";
import OperationalPopup from './OperationalPopup';
import axiosInstance from '../../axiosInstance';
import { ToastContainer, toast } from "react-toastify";
import ConfirmDialog from '../../ConfirmDialog/ConfirmDialog';
import CommonFooter from '../../CommonFooter/CommonFooter';
import { useRolePermission } from '../../hooks/useRolePermission';

const Operational = () => {

  const checkPermission = useRolePermission();

  const [tableData, setTableData] = useState([]);
  const [limit, setLimit] = useState(5);
  const [currentPage, setCurrentPage] = useState(0);
  const [skip, setSkip] = useState(0);
  const [total, setTotal] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [editData, setEditData] = useState(null);
  const [reload, setReload] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  const popupRef = useRef(null);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  // Fetch Operational Assumptions with search support
  const fetchOperational = async (search = '') => {
    try {
      const res = await axiosInstance.get(`/costsolution/operationalassumptions`, {
        params: { limit, skip, search },
      });
      if (Array.isArray(res.data.operationalassumptions)) {
        setTableData(res.data.operationalassumptions);
        const totalCount = res.data.totalCount || 0;
        setTotal(totalCount);
        setTotalPages(Math.ceil(totalCount / limit));
      } else {
        setTableData([]);
      }
    } catch (error) {
      toast.error("Failed to fetch data");
      console.error("Fetch Error:", error);
    }
  };

  useEffect(() => {
    fetchOperational(searchTerm);
  }, [limit, skip, reload, searchTerm]);

  const handleSearch = (term) => {
    setSearchTerm(term);
    setCurrentPage(0);
    setSkip(0);
  };

  const handleAddNewClick = (row = null) => {
    setEditData(row ? { id: row.id } : null);
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setEditData(null);
    setIsPopupOpen(false);
  };

  const handleLimitChange = (e) => {
    const newLimit = Number(e.target.value);
    setLimit(newLimit);
    setCurrentPage(0);
    setSkip(0);
  };

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
    setSkip(selected * limit);
  };

  const handleSelectAll = () => {
    setSelectedRows(selectedRows.length === tableData.length ? [] : tableData.map(row => row.id));
  };

  const handleRowSelect = (id) => {
    setSelectedRows(prev =>
      prev.includes(id) ? prev.filter(rowId => rowId !== id) : [...prev, id]
    );
  };

  const handleDeleteRow = (id) => {
    setDeleteId(id);
    setConfirmOpen(true);
  };

  const confirmDelete = async () => {
    if (!deleteId) return;
    try {
      await axiosInstance.delete(`/costsolution/operationalassumptions/delete/${deleteId}`);
      toast.success("Deleted successfully");
      setReload(prev => !prev);
    } catch (error) {
      toast.error(error.response?.data?.message || "Delete failed");
      console.error("Delete error:", error);
    } finally {
      setConfirmOpen(false);
      setDeleteId(null);
    }
  };

  const cancelDelete = () => {
    setConfirmOpen(false);
    setDeleteId(null);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        closePopup();
      }
    };
    if (isPopupOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isPopupOpen]);

  const isAllSelected = selectedRows.length === tableData.length && tableData.length > 0;
  const isAnySelected = selectedRows.length > 0;

  return (
    <>
      <Header onSearch={handleSearch} />
      <div className="container">
        <div className="header">
          <div className="left-header">
            <h3>All Operational Assumptions ({total})</h3>
          </div>
          <div className="right-header">

            {checkPermission("Operational Assumption", "create_permission") && !isAnySelected && (
              <button id="addNewBtn" onClick={() => handleAddNewClick()}>
                Add New
              </button>
            )}

          </div>
        </div>

        <table>
          <thead>
            <tr>
              <th style={{ width: "1px" }}>
                <input type="checkbox" checked={isAllSelected} onChange={handleSelectAll} />
              </th>
              <th>S.No</th>
              <th>Project</th>
              <th>Assumption</th>
              <th>Terms</th>
              <th>Date</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {tableData.length > 0 ? (
                tableData.map((row, index) => (
              <tr key={row.id}>
                <td>
                  <input
                    type="checkbox"
                    checked={selectedRows.includes(row.id)}
                    onChange={() => handleRowSelect(row.id)}
                  />
                </td>
                <td>{skip + index + 1}</td>
                <td>{row.projectName}</td>
                <td>{row.termName}</td>
                <td>{row.assumptionName || ""}</td>
                <td>{row.modifieddate}</td>
                <td>
                  <div className="actions">

                    {checkPermission("Operational Assumption", "edit_permission") && (
                      <span className="edit-icon">
                        <img
                          src={Vector}
                          alt="Edit Icon"
                          width="20"
                          height="20"
                          onClick={() => handleAddNewClick(row)}
                        />
                      </span>
                    )}

                    {checkPermission("Operational Assumption", "delete_permission") && (
                      <span
                        className="delete-icon"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleDeleteRow(row.id)}
                      >
                        <img src={Delete} alt="Delete Icon" width="40" height="40" />
                      </span>
                    )}

                  </div>
                </td>
                  </tr>
                ))  ) : (
              <tr>
                {searchTerm && tableData.length === 0 && (
                  <td colSpan="7" style={{ textAlign: 'center', padding: '20px', fontSize: '14px', color: '#666' }}>
                    No Operational assumption found matching "{searchTerm}"
                  </td>
                )}
              </tr>
            )}
          </tbody>
        </table>

        <div className="pagination-container d-flex align-items-center justify-content-between mt-3">
          <div className="Limit-Dropdown">
            <label htmlFor="limit" className="fw-semibold">Items per page:</label>
            <select
              id="limit"
              value={limit}
              onChange={handleLimitChange}
              className="form-select d-inline w-auto"
            >
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="15">15</option>
              <option value="20">20</option>
            </select>
          </div>

          <div className="d-flex align-items-center gap-4">
            <ReactPaginate
              previousLabel={<span style={{ userSelect: "none" }}>Previous</span>}
              nextLabel={<span style={{ userSelect: "none" }}>Next</span>}
              pageCount={totalPages > 0 ? totalPages : 1}
              onPageChange={handlePageClick}
              containerClassName={"pagination d-flex"}
              activeClassName={"active"}
              marginPagesDisplayed={1}
              pageRangeDisplayed={3}
              forcePage={currentPage}
            />
          </div>
        </div>
      </div>

      {isPopupOpen && (
        <div className="popup-overlay">
          <div className="popup-content" ref={popupRef}>
            <OperationalPopup
              closePopup={closePopup}
              editData={editData}
              triggerReload={() => setReload(prev => !prev)}
            />
          </div>
        </div>
      )}
      <CommonFooter />
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
      <ConfirmDialog
        open={confirmOpen}
        title="Delete Confirmation"
        message="Are you sure you want to delete this Operational Assumption?"
        confirmText="Delete"
        cancelText="Cancel"
        onConfirm={confirmDelete}
        onCancel={cancelDelete}
      />
    </>
  );
};

export default Operational;
